module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.protocol) ? _c('Breadcrumb', {
    attrs: {
      "protocol": _vm.protocol,
      "categories": _vm.categories
    }
  }) : _vm._e(), _vm._v(" "), _c('main', {
    attrs: {
      "id": "protocol"
    }
  }, [_c('aside', {
    staticClass: "refine"
  }, [_c('Categories')], 1), _vm._v(" "), _c('section', {
    staticClass: "results protocol"
  }, [(_vm.protocol) ? _c('div', {
    attrs: {
      "id": "title-block"
    }
  }, [_c('div', {
    staticClass: "protocol-title"
  }, [_c('h1', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v(_vm._s(_vm.protocol.title))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "selected-protocol"
  }, [(_vm.is404) ? _c('Error404Page') : _vm._e(), _vm._v(" "), (_vm.protocol) ? _c('span', [_c('Protocol', {
    attrs: {
      "protocol": _vm.protocol,
      "headers": _vm.topHeaders
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "robot-tab"
  }, [_vm._l((_vm.allTabs), function(tab) {
    return (_vm.downloadUrls[tab]) ? _c('span', {
      class: {
        selected: (tab === _vm.currentTab)
      },
      on: {
        "click": function($event) {
          _vm.navigateTab(tab)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.tabNames[tab]) + "\n            ")]) : _vm._e()
  }), _vm._v(" "), _c('span', {
    staticClass: "filler"
  })], 2), _vm._v(" "), _c('h2', {
    staticClass: "download-protocol-header"
  }, [_vm._v("Download Protocol:")]), _vm._v(" "), (_vm.protocol.flags['embedded-app'] === false && _vm.downloadUrls[_vm.currentTab]) ? _c('ParameterizeAndDownload', {
    attrs: {
      "downloadUrl": _vm.downloadUrls[_vm.currentTab],
      "protocolSlug": _vm.protocol.slug,
      "robotTab": _vm.tabNames[_vm.currentTab],
      "protocolData": _vm.protocolData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentTab === 'ot1') ? _c('Setup', {
    attrs: {
      "protocol": _vm.selectedOT1protocol
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ot2_deck_map_wrapper"
  }, [_c('div', {
    staticClass: "ot2_deck_map"
  }, [(_vm.currentTab === 'ot2') ? _c('iframe', {
    attrs: {
      "src": _vm.ot2DeckUrl
    }
  }) : _vm._e()])]), _vm._v(" "), _c('Protocol', {
    attrs: {
      "protocol": _vm.protocol,
      "headers": _vm.bottomHeaders
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getIframeSrc) ? _c('EmbeddedApp', {
    attrs: {
      "src": _vm.getIframeSrc
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.protocol) ? _c('button', {
    staticClass: "back-to-top",
    on: {
      "click": _vm.backToTop
    }
  }, [_vm._v("\n        BACK TO TOP\n      ")]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ba48a1f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProtocolView.vue
// module id = 233
// module chunks = 2